import { BaseItem, ExportState, ReviewState } from '../common';
import { Recommendation } from '../patientAdvisory';
import * as Evidence from './evidence.js';

export enum FindingType {
  CareGap = 'CARE_GAP',
  Hcc = 'HCC',
}

export enum CareGapStatus {
  ClosedDiscrete = 'CLOSED_DISCRETE',
  ClosedNonDiscrete = 'CLOSED_NON_DISCRETE',
  Excluded = 'EXCLUDED',
  Na = 'NA',
  Open = 'OPEN',
  Unknown = 'UNKNOWN',
}

export enum HccStatus {
  Captured = 'CAPTURED',
  NotCaptured = 'NOT_CAPTURED',
  Suspected = 'SUSPECTED',
}

export interface BaseFindingFields {
  type: FindingType;
  ehrInformationId: string;
  encounterId: string | null;
  patientAdvisoryId: string | null;
  icd10: string | null;
  hccCode: string | null;
  suspectText: string | null;
  careGapType: Recommendation | null;
  status: CareGapStatus | HccStatus;
  reviewState: ReviewState;
  rejectionReason: string | null;
  exportState: ExportState;
}

export type FilterOptions = Partial<{
  type: FindingType;
  ehrInformationId: string;
  encounterId: string | null;
  patientAdvisoryId: string | null;
  icd10: string | null;
  hccCode: string | null;
  careGapType: Recommendation | null;
  status: CareGapStatus | HccStatus;
  reviewState: ReviewState;
  exportState: ExportState;
}>;

export interface Finding extends BaseFindingFields, BaseItem {
  evidence: Evidence.Evidence[] | null;
}

interface UpdateValues
  extends Partial<
    Omit<
      BaseFindingFields,
      | 'type'
      | 'ehrInformationId'
      | 'encounterId'
      | 'patientAdvisoryId'
      | 'icd10'
      | 'hccCode'
      | 'suspectText'
      | 'careGapType'
    >
  > {}

type UpdateEvidenceValues = Omit<Evidence.UpdateEvidenceValues, 'reviewState'>;
export interface UpdateFindingValues extends UpdateValues {
  evidence?: UpdateEvidenceValues[] | null;
}
